module.exports = __webpack_public_path__ + "static/media/applications.197bc473.png";